import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import isEqual from 'lodash/isEqual';
import { USER_TYPE_SUPER_ADMIN } from 'src/config-global';
import { useGetUserProfileQuery } from 'src/store/Reducer/settings';
import { setUser } from 'src/store/slices/userSlice';
import { useMockedUser } from './use-mocked-user';

// Fields the Get Profile API owns and that the Header avatar / contractor sidebar logo
// read from Redux. When the freshly-fetched profile differs, push it into Redux once so
// `useMockedUser` consumers stay correct on first login and update live after a save —
// without every component needing to subscribe to the query itself.
const SYNCED_FIELDS = ['name', 'email', 'phone', 'image', 'company', 'platform_access', 'payment_role', 'role'];

export function useProfileSync() {
  const dispatch = useDispatch();
  const { user } = useMockedUser();

  const role = user?.user_type === USER_TYPE_SUPER_ADMIN ? 'admin' : 'contractor';

  const { data } = useGetUserProfileQuery({ role }, { skip: !user?._id });

  const body = data?.body;

  useEffect(() => {
    if (!user?._id || !body) return;

    const changed = SYNCED_FIELDS.some(
      (key) => body[key] !== undefined && !isEqual(body[key], user[key])
    );
    if (!changed) return;

    const next = { ...user };
    SYNCED_FIELDS.forEach((key) => {
      if (body[key] !== undefined) next[key] = body[key];
    });
    next.photoURL = body.image ?? next.photoURL;

    dispatch(setUser(next));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [body]);
}
